<template>
  <div v-touch:swipe.top="swipeup" v-touch:swipe.bottom="swipedown" :class="{english:$i18n.locale=='en'}">
    <headLine ref="dialog" showbar="true" @on-locale-change="onLocaleChange" index="8">
      {{$t('solution3.name')}}
    </headLine>  
    <!-- <div class="menu_toolbar2 center" :class="{menu_toolbar:!showmenu_bar}"> -->
<!--         <router-link to="/solution" style="color:rgba(255,255,255,0.5)">{{$t('solution3.name1')}}</router-link>
        <router-link to="/solution1"  style="color:rgba(255,255,255,0.5)">{{$t('solution3.name2')}}</router-link> -->
    <!-- </div>  -->
     <div class="banner">
         <img :src="imglist[0]" alt="">  
         <h1 class="banner_title" style="top:2.77rem" v-html="$t('solution3.banner_text')">

         </h1> 
         <div class="center" style="position:absolute;top:4.4rem;width:100%">
           <router-link to="/download"><a class="button_default"  v-html="$t('solution3.banner_botton')">
            
           </a></router-link>
         </div> 
     </div>
     <div class="content center">
      <div class="content_item" style="padding-bottom:0.7rem">
        <h3 class="content_item_title" v-html="$t('solution3.title1')" style="width:90%;margin:0 auto"> 
        </h3>
        <h3 class="content_item_text content_item_text1" v-html="$t('solution3.text1')" style="width:90%;margin-left:auto;margin-right:auto;text-align:justify">
        </h3>
        <h3 class="content_item_text" v-html="$t('solution3.text2')">
        </h3>
        <img v-lazy="imglist[1]" alt="" style="width:6.86rem;height:3.37rem;margin:0.7rem auto 0 auto" v-if="$i18n.locale=='ch'">  
        <img v-lazy="imglist[10]" alt="" style="width:6.86rem;height:3.37rem;margin:0.7rem auto 0 auto" v-if="$i18n.locale=='en'">  
      </div>
      <div>
        <div class="content_item" style="background:#f3f9ff;padding-bottom:0.7rem">
          <div>
            <div class="picture_list clearfix">
                <div class="fl left_pic ">
                  <div class="pic_box">
                    <div class="middle pic_box_text" v-html="$t('solution3.text4')">
                      秀场VR直播
                    </div>

                    <img v-lazy="imglist[2]" alt="" style="margin-top:0">
                  </div>

                </div>
                <div class="fr right_pics">
                  <div class="pic_box">
                    <div class="middle pic_box_text" v-html="$t('solution3.text6')">
                      体育VR直播
                    </div>
                    <img v-lazy="imglist[3]" alt="" style="margin-top:0">
                  </div>
                  <div class="pic_box">

                    <div class="middle pic_box_text" v-html="$t('solution3.text8')">
                      演出VR直播
                    </div>
                    <img v-lazy="imglist[4]" alt="" style="margin-top:0">
                  </div>
                </div>
            </div>
          </div>
        </div>

      </div>


          <div class="content_item" style="padding-bottom:0.7rem">
            <h3 class="content_item_title" v-html="$t('solution3.text19')"> 
              威尔云 6 大特性 
            </h3>
            <div class="feature clearfix">
              <div class="fl">
                <ul>
                  <li>
                    <span class="feature_pic feature_pic1"></span>
                    <h3 class="content_item_title" v-html="$t('solution3.text20')"> 
                      低宽带
                    </h3>
                  </li>
                  <li>
                    <span class="feature_pic feature_pic5"></span>
                    <h3 class="content_item_title" v-html="$t('solution3.text24')"> 
                      低功耗
                    </h3>
                  </li>
                  <li>
                    <span class="feature_pic feature_pic7"></span>
                    <h3 class="content_item_title" v-html="$t('solution3.text28')"> 
                      服务稳定可靠
                    </h3>
                  </li>
                </ul>

              </div>
              <div class="fr">
                <ul>
                  <li>
                    <span class="feature_pic feature_pic2"></span>
                    <h3 class="content_item_title" v-html="$t('solution3.text22')"> 
                      低延迟
                    </h3>
                  </li>
                  <li>
                    <span class="feature_pic feature_pic3"></span>
                    <h3 class="content_item_title" v-html="$t('solution3.text26')"> 
                      标准协议
                    </h3>
                  </li>
                  <li>
                    <span class="feature_pic feature_pic6"></span>
                    <h3 class="content_item_title" v-html="$t('solution3.text30')"> 
                      多终端适配
                    </h3>
                  </li>
                </ul>
              </div>
            </div>
            <div class="center">
               <router-link to="/technology" class="button_default2" style="margin-top:0.2rem">{{$t('solution3.text32')}}</router-link>
            </div>
          </div>
          <div class="content_item " style="background:#f3f9ff;padding-bottom:0.7rem">
                  <div clas="multi-platform">
                    <h3 class="content_item_title">
                      {{$t('solution3.text33')}}
                    </h3>
            <!--         <div class="multi-platform_text">
            支持Android、iOS、Gear VR、HTML5，只需一键，即刻享受
                    </div> -->
                    <div >
                      <ul class="platform_pic clearfix">
                        <li>
                          <img src="../assets/images/solution/andriod.png" alt="">
                        </li>
                        <li>
                          <img src="../assets/images/solution/ios.png" alt="">
                        </li>
                        <li>
                          <img src="../assets/images/solution/h5.png" alt="">
                        </li>
                      </ul>
                    </div>

                    <div class="multi-platform_button">
                      <a class="button_default2" href="javascript:void(0)" @click="showDialog()" style="margin-top:2.48rem">{{$t('solution3.text34')}}</a>
                    </div>
                  </div>
          </div>

          <div class="requestion_wrap">
            <div class="requestion">
              <h3 class="requestion_title">
                {{$t('solution3.text35')}}
              </h3>
              <dl>
                <dt @click="show1=!show1">{{$t('solution3.text36')}}<span class="fold_button"  :class="{fold_button2:show1}"></span></dt>
                <dd v-show="show1">{{$t('solution3.text37')}}</dd>
              </dl>
              <dl>
                <dt @click="show2=!show2">{{$t('solution3.text38')}}<span class="fold_button" :class="{fold_button2:show2}" ></span></dt>
                <dd v-show="show2">{{$t('solution3.text39')}}</dd>
              </dl>
              <dl>
                <dt @click="show3=!show3">{{$t('solution3.text40')}}<span class="fold_button" :class="{fold_button2:show3}" ></span></dt>
                <dd v-show="show3">{{$t('solution3.text41')}}</dd>
              </dl>
              <dl>
                <dt  @click="show4=!show4">{{$t('solution3.text42')}}<span class="fold_button" :class="{fold_button2:show4}"></span></dt>
                <dd v-show="show4">{{$t('solution3.text43')}}</dd>
              </dl>
              <dl>
                <dt  @click="show5=!show5">{{$t('solution3.text47')}}<span class="fold_button" :class="{fold_button2:show5}"></span></dt>
                <dd v-show="show5">{{$t('solution3.text48')}}</dd>
              </dl>
            </div>
          </div>
      <div class="content_item content_bg" v-lazy:background-image="imglist[7]">
       <div class="center">
        <a  class="button_default2" style="margin-bottom:2.26rem" @click="showDialog2()">{{$t('solution3.text45')}}</a>
      </div>

       </div>


     </div>
     <footerLine></footerLine>
  </div>
</template>

<script>
import Vue from 'vue'
import headLine from "./header"
import footerLine from "./footer"
import i18n from '../common/i18n'

export default {
  i18n:i18n,
  data(){
    return{
      imglist:[
        "/static/images/solution/banner.png",
        "/static/images/solution/1803.png",
        "/static/images/solution/img4.png",
        "/static/images/solution/img5.png",
        "/static/images/solution/img6.png",
        "/static/images/solution/360.png",
        "/static/images/solution/img4.png",
                "/static/images/about/bg.png",
        "/static/images/solution/img5.png",
        "/static/images/solution/img6.png",
        "/static/images/solution/3603.png",
        "/static/images/solution/3601.png",

      ],
      show1:false,
      show2:false,
      show3:false,
      show4:false,
      show5:false,
            showmenu_bar:true
    }
  },
  created(){
    var language = navigator.language; //取得浏览器版本语言
    var initLanguage = "";
    if(localStorage.locale){
      this.$i18n.locale = localStorage.locale;
    }else{
      if (language.indexOf('zh') > -1){
        initLanguage="ch"; //中文页面
      }else if (language.indexOf('en') > -1){
        initLanguage="en"; //英文页面
      }
      this.$i18n.locale = initLanguage;
    }
    var self = this;
    document.addEventListener("scroll",function(){
      var scrollTop = document.body.scrollTop;
          if(scrollTop>10){
            if(scrollTop>=self.scrollTop){
                // self.showmenu_bar = false;
            }else{
                // self.showmenu_bar = true;
            }
              setTimeout(function(){self.scrollTop = scrollTop;},100); 
          }
    },false)
  },
  methods:{
      showDialog2(){
      this.$refs.dialog.showNext = false;
      this.$refs.dialog.showDialog = true;
      if(this.$i18n.locale=="en"){
        this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";

      }else{
        this.$refs.dialog.content_type2 = "申请使用威尔云";

      }
    },
    onLocaleChange:function(val){
      this.$i18n.locale=val;
    },
    swipeup(){
      // this.showmenu_bar=false
    },
    swipedown(){
      // this.showmenu_bar=true
    },
            showDialog(){
                this.$refs.dialog.showDialog = true;
                this.$refs.dialog.showNext = false;
                if(this.$i18n.locale=="en"){
                  this.$refs.dialog.content_type2 = "Get VRVIU Cloud Trial";

                }else{
                  this.$refs.dialog.content_type2 = "申请使用威尔云";

                }
        }
  },
  components:{
    headLine,
    footerLine,
    show1:false,
    show2:false
  }
}
</script>

<style scoped>
.english .banner .center{
  top:4.6rem;
}
.english .banner h1{
  top:2.6rem!important;;
}
.banner h1{
  top:2.5rem!important;;
}
.platform_pic li{
  float: left;
  margin-right: 0.17rem;
  width:1.36rem;
  height: 1.36rem
}
.platform_pic img{
  margin-top: 0!important;
  width: 100%;
  height: 100%;
} 

.platform_pic li:last-child{
  margin-right: 0;
}
.platform_pic{
  margin-top: 0.4rem;
position: absolute;
left:50%;
transform: translate(-50%,0);
width:4.5rem;
}
.multi-platform{
  position: relative;
}

.multi-platform_button .button3{
  margin-top: 2rem;
  margin-bottom: 1rem;
}
.multi-platform_title{
  font-size: .48rem;
  color:#282828;
  margin-top: 1.9rem;
  margin-bottom: 1rem;

}
.multi-platform_text{
  font-size: 0.22rem;
  color:#646464;
  margin-bottom: 0.7rem;
}
.feature .content_item_title{
  font-size: 0.3rem;
    margin:0.34rem 0 0.5rem 0
}
.feature_pic{
  display: inline-block;
  width: 1.2rem;
  height: 1.2rem;
  background: url(../assets/images/solution/icon1.png) no-repeat;
  background-size: cover;
}
.pic_box_text{
  width: 100%;
}
.feature_pic2{
  background: url(../assets/images/solution/icon4.png) no-repeat;
  background-size: cover;
}
.feature_pic3{
  background: url(../assets/images/solution/icon2.png) no-repeat;
  background-size: cover;
}
.feature_pic4{
  background: url(../assets/images/solution/icon4.png) no-repeat;
  background-size: cover;
}
.feature_pic5{
  background: url(../assets/images/solution/icon7.png) no-repeat;
  background-size: cover;
}
.feature_pic6{
  background: url(../assets/images/solution/icon6.png) no-repeat;
  background-size: cover;
}
.feature_pic7{
  background: url(../assets/images/solution/icon3.png) no-repeat;
  background-size: cover;
}
.english .feature{
  width: 6rem;
}
.feature{
  width: 5.3rem;
  margin: 0 auto;
  margin-top: 0.4rem;
}
.banner{
  height: 7rem!important;
}
.banner img{
  height:7rem!important;
}

</style>



// WEBPACK FOOTER //
// solution2.vue?34340043